import { FC, useLayoutEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ListGroup } from 'react-bootstrap';
import { WeekProps } from './_models';
import { useNavigationData } from '../../../modules/NavigationProvider';
import logo from '../../../assets/img/logo.png';

const WeekComponent: FC<WeekProps> = ({
  ledDays,
  setLedDays,
  setShowPicker,
}) => {
  const { t } = useTranslation('schedule');
  const { setHeaderText } = useNavigationData();

  useLayoutEffect(() => {
    setHeaderText(t('title.repeat'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [weekdays, setWeekdays] = useState([
    { label: t('sunday'), active: ledDays.includes(0) },
    { label: t('monday'), active: ledDays.includes(1) },
    { label: t('tuesday'), active: ledDays.includes(2) },
    { label: t('wednesday'), active: ledDays.includes(3) },
    { label: t('thursday'), active: ledDays.includes(4) },
    { label: t('friday'), active: ledDays.includes(5) },
    { label: t('saturday'), active: ledDays.includes(6) },
  ]);

  const handleDayClick = (index: number) => {
    const newWeekdays = [...weekdays];
    newWeekdays[index].active = !newWeekdays[index].active;
    setWeekdays(newWeekdays);
  };

  const newLedDays = useMemo(
    () => weekdays.map((_d, idx) => idx).filter((idx) => weekdays[idx].active),
    [weekdays]
  );

  const handleSave = () => {
    setLedDays(newLedDays);

    setShowPicker(true);
  };

  return (
    <div className="d-flex flex-column">
      <ListGroup style={{ width: '200px' }}>
        {weekdays.map((day, index) => (
          <ListGroup.Item
            key={index}
            action
            onClick={() => handleDayClick(index)}
            className="d-flex justify-content-between"
          >
            <span>{day.label} </span>
            {day.active && <img src={logo} height={20} alt="vihupole" />}
          </ListGroup.Item>
        ))}
      </ListGroup>
      <div className="d-flex justify-content-between">
        <Button
          variant="outline-dark"
          size="sm"
          className="mt-3 text-uppercase"
          onClick={() => setShowPicker(true)}
        >
          {t('cancel')}
        </Button>
        <Button
          variant="outline-dark"
          size="sm"
          className="ms-auto mt-3 text-uppercase"
          onClick={() => handleSave()}
          disabled={!newLedDays.length}
        >
          {t('save')}
        </Button>
      </div>
    </div>
  );
};

export default WeekComponent;
